import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { TableComponent } from '../table/table.component';

@Component({
  selector: 'app-setting-rolling',
  templateUrl: './setting-rolling.component.html',
  styleUrls: ['./setting-rolling.component.scss']
})
export class SettingRollingComponent  implements AfterViewInit {
  public company_uuid;

  @ViewChild("table", { static: false }) tb: TableComponent;

  constructor(private http: HttpService, private cdr: ChangeDetectorRef) {
    this.company_uuid = this.http.getStaticSelectedCompany();
   }

  ngAfterViewInit(): void {
    const setting = 
      { post: {url: '/admin/setting/rolling/get', data: {page_nat: true}},
        disabled_pagenat: false,
        fields: [
          {label: 'No', type: 'index'}, 
          {label: 'Game', type: 'string', key: 'game_title', filter: 'string'}, 
          {label: 'Category', type: 'string', key: 'category_title', filter: 'string'}, 
          {label: 'Self', type: 'string', key: 'self', filter: 'string'}, 
          {label: 'Level 1', type: 'string', key: 'level_1', filter: 'string'}, 
          {label: 'Level 2', type: 'string', key: 'level_2', filter: 'string'}, 
          {label: 'Status', type: 'status', key: 'status', filter: 'status'}, 
          {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/' + this.company_uuid + '/setting-rolling/form', hide: true},
          {label: 'Delete', type: 'delete', key: 'uuid', table: 'setting_rolling', title: 'title', hide: true},
        ]}
    this.tb.init(setting);
    this.cdr.detectChanges();
  }

}
